/* eslint no-console: 0 */

export function logError(message, error) {
  console.log(message || 'Error', error)
  if (window.Rollbar) {
    window.Rollbar.error(message, error)
  }
}

export const STRIPE_REJECTION = 'stripe_rejection'

export function stripeRejectionError(responseJson) {
  switch (responseJson.meta.subcode) {
    case 'invalid_number':
      return ['Your card number is invalid.']
    case 'invalid_exp_month':
      return ["Your card's expiration date is invalid."]
    case 'invalid_exp_year':
      return ["Your card's expiration date is invalid."]
    case 'invalid_cvc':
      return ["Your card's security code is invalid."]
    case 'invalid_zip':
      return ['Your cards zip code is invalid.']
    case 'expired':
      return ['Your card has expired.']
    case 'declined':
      return ['Your card was declined.']
    case 'processing_error':
      return ['An error occurred while processing your card.']
    case 'invalid_request_error':
      return responseJson.meta.message
        ? [responseJson.meta.message]
        : ['There was an error with your account info. Please check all fields and try again.']
    default:
      return ['There was an error processing your account info.']
  }
}
